module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-440.0c746b07.jpg";